import Box from '@components/base/Box'
import { Button } from '@components/inputs/Button'
import Modal from '@components/base/Modal'
import {
  EventEmailTemplate,
  EventEmailTrigger,
  NotificationStatus,
} from '@graphql/__generated/graphql'
import CreateEventLayout from '@layouts/CreateEventLayout'
import { useEventEditor } from '@libs/CreateEvent/useEventEditor'
import React, { useMemo, useState } from 'react'
import Table from '@components/base/Table'
import TableRowActions from '@components/event/TableRowActions'
import moment from 'moment'
import EmailBuilderUI, {
  clearEmailContentCache,
} from '@components/email-builder'
import {
  EmailTemplateListItem,
  SCHEDULED_EMAIL_TRIGGER,
} from '@components/email-builder/emailbuilder.type'
import { EmailPreview } from '@components/email-builder/emailPreview'
import { useMutation } from '@apollo/client'
import { TRIGGER_EVENT_EMAIL } from '@graphql/events/triggerEmailEvent'
import {
  findLegacyEmailSchedule,
  removeLegacyEmailSchedule,
} from '@libs/CreateEvent/emailScheduling'
import { v4 } from 'uuid'

const NotificationsForm = () => {
  const { formData, setFormData, errors, setErrors, refetchEvent } =
    useEventEditor()

  const [showEmailModal, setShowEmailModal] = useState(false)

  const [triggerMail] = useMutation(TRIGGER_EVENT_EMAIL)

  const [emailModalData, setEmailModalData] = useState<EmailTemplateListItem>(
    {}
  )

  // const [errors, setErrors] = useState<ErrorType | undefined>(undefined)

  const errorHandler =
    (id: string, alert: boolean = false) =>
    (message: string, testId: string) => {
      const payload = [...errors]

      const hasError = !!message || message !== ''
      const isCleared = payload.find((f) => f.eleId === testId) && !hasError

      if (isCleared) return setErrors(payload.filter((f) => f.eleId !== testId))

      const isDuplicate = !!payload.find((p) => p.eleId === testId)

      const newError = {
        step: id ?? 'unknown',
        message,
        eleId: testId,
        alert,
      }

      if (!isDuplicate && hasError) setErrors([...payload, newError])
    }

  const emailBuilderModal = useMemo(
    () => (
      <Modal
        show={showEmailModal}
        setShow={setShowEmailModal}
        title={`${
          emailModalData?.editIndex !== undefined ||
          emailModalData.editIndex === 0
            ? 'Edit'
            : 'Create'
        } Email`}
        className={`flex overflow-visible w-full flex-col justify-between`}
      >
        <EmailBuilderUI
          onSubmit={(data) => {
            console.log({ data })
            setEmailModalData(data)
          }}
          enablePreview
          setError={errorHandler('email_builder')}
          template={emailModalData}
        />
        <Button
          className="mb-4 ml-auto"
          title={
            emailModalData.trigger === SCHEDULED_EMAIL_TRIGGER
              ? 'Schedule Email'
              : 'Save Email'
          }
          type="primary"
          disabled={
            emailModalData.trigger === SCHEDULED_EMAIL_TRIGGER &&
            (!emailModalData.schedule?.runAt ||
              !moment(emailModalData.schedule.runAt).isAfter(moment()))
          }
          onClick={(e) => {
            e.preventDefault()
            console.log({
              templates: formData?.emailTemplates,
              emailModalData,
            })

            let payload: typeof formData = {
              ...formData,
              emailTemplates: [...(formData?.emailTemplates ?? [])],
            }

            const hasRegistrationConfirmationTemplate =
              !!payload?.emailTemplates?.find(
                (f) => f.trigger === EventEmailTrigger.Confirmation
              )

            const newEmail: EventEmailTemplate = {
              templateId: emailModalData.templateId || v4(),
              title: emailModalData.title,
              enabled: true,
              trigger: emailModalData.trigger,
              data: emailModalData.data,
              content: emailModalData.content,
              schedule:
                emailModalData.trigger === SCHEDULED_EMAIL_TRIGGER
                  ? emailModalData.schedule
                  : undefined,
            }

            if (!payload.emailTemplates) payload.emailTemplates = []

            if (
              newEmail.trigger === EventEmailTrigger.Confirmation &&
              hasRegistrationConfirmationTemplate
            )
              payload = {
                ...payload,
                emailTemplates: [
                  ...payload.emailTemplates.map((template) =>
                    template.trigger === EventEmailTrigger.Confirmation
                      ? {
                          ...template,
                          trigger: EventEmailTrigger.Manual,
                        }
                      : template
                  ),
                ],
              }

            if (!!payload.emailTemplates) {
              if (emailModalData.editIndex === 0 || emailModalData.editIndex)
                payload.emailTemplates[emailModalData.editIndex] = newEmail
              else payload.emailTemplates.push(newEmail)
            }

            if (emailModalData.legacyScheduleTimestamp)
              payload.notifications = removeLegacyEmailSchedule({
                notifications: payload.notifications,
                templateTitle: emailModalData.originalTitle,
                timestamp: emailModalData.legacyScheduleTimestamp,
              })

            console.log({ payload })
            setFormData(payload)
            clearEmailContentCache({
              type: 'event',
              scopeId: formData?.eventId,
              template: emailModalData,
            })

            setShowEmailModal(false)
            setEmailModalData({})
          }}
        />
      </Modal>
    ),
    [formData, showEmailModal, emailModalData]
  )

  const [actionLoading, setActionLoading] = useState(false)

  return (
    <>
      {emailBuilderModal}

      <Box className="size-full">
        {/* {errors ? ( */}
        {/*   <Box */}
        {/*     ignoreTheme */}
        {/*     className={`transition-all my-2 ${ */}
        {/*       errors.message ? 'opacity-100' : 'opacity-0' */}
        {/*     } text-red-500 text-sm font-bold`} */}
        {/*   > */}
        {/*     {errors.message ?? ''} */}
        {/*   </Box> */}
        {/* ) : null} */}

        <Box className="flex items-center space-x-2 mb-4 mt-6">
          <Box className="text-xl">Emails</Box>
          <Button
            onClick={() => {
              setEmailModalData({
                title: `Email Template ${formData?.emailTemplates?.length ?? 1}`,
                trigger:
                  (formData?.emailTemplates?.length ?? 0) > 0
                    ? EventEmailTrigger.Manual
                    : EventEmailTrigger.Confirmation,
              })
              setShowEmailModal(true)
            }}
            title="Create New Email"
            type="secondary"
            size="small"
          />
        </Box>
        <Table
          sortable
          items={formData?.emailTemplates ?? undefined}
          onSort={(e) => {
            console.log({ e })
            const payload = {
              ...formData,
              emailTemplates: e,
              // emailTemplates: e.map((m) => {
              //   try {
              //     delete m.sentDateTime
              //   } catch (_) {}
              //   return m
              // }),
            }
            setFormData(payload)
          }}
          tableHeading={['Subject', 'Delivery', 'Status / time', '']}
          rows={formData?.emailTemplates?.map((emailTemplates, index) => {
            const legacySchedule = emailTemplates.schedule
              ? undefined
              : findLegacyEmailSchedule(
                  formData.notifications,
                  emailTemplates.title
                )
            const scheduleStatus =
              emailTemplates.schedule?.status ?? legacySchedule?.status
            const scheduledAt =
              emailTemplates.schedule?.runAt ?? legacySchedule?.timestamp
            const isScheduled =
              (emailTemplates.trigger === SCHEDULED_EMAIL_TRIGGER &&
                !!emailTemplates.schedule) ||
              !!legacySchedule

            return [
              emailTemplates?.title?.toUpperCase() ?? `No Title (${index})`,
              <Box
                key={`notification-delivery-${index}`}
                className="rounded-md capitalize"
              >
                {isScheduled ? 'Scheduled send' : emailTemplates.trigger}
              </Box>,
              isScheduled
                ? `${
                    scheduleStatus === NotificationStatus.Sent
                      ? 'Sent'
                      : scheduleStatus === NotificationStatus.Failed
                        ? 'Failed'
                        : 'Scheduled for'
                  } ${moment(scheduledAt).format('D MMMM YYYY, h:mm A')}`
                : emailTemplates.sentDateTime
                  ? moment(emailTemplates.sentDateTime)
                      .format('D MMMM YYYY, h:mm A')
                      .toString()
                  : emailTemplates.trigger === EventEmailTrigger.Manual
                    ? 'Not sent'
                    : 'On registration',
              <TableRowActions
                key={index}
                action={[
                  {
                    title: 'Send',
                    show:
                      emailTemplates.trigger === EventEmailTrigger.Manual &&
                      !isScheduled,
                    loading: actionLoading,
                    onClicked: () => {
                      if (!!formData.eventId && !!emailTemplates.title) {
                        setActionLoading(true)
                        triggerMail({
                          variables: {
                            eventId: formData.eventId,
                            template: emailTemplates.title,
                          },
                        })
                          .then(() => {
                            refetchEvent()
                          })
                          .finally(() => setActionLoading(false))
                      }
                    },
                    confirmModal: {
                      title: 'Are you sure?',
                      content: (
                        <Box className="pt-6 pb-6">
                          <Box className="my-2 mb-6">
                            Are you sure you want to send this email to all
                            attendees? Please ensure your email template is
                            correct before confirming.
                          </Box>
                          <Box className="h-[50vh]">
                            <EmailPreview
                              resizeEnabled={false}
                              content={emailTemplates.content!}
                            />
                          </Box>
                        </Box>
                      ),
                    },
                  },
                  {
                    title: 'Duplicate',
                    show:
                      emailTemplates.trigger !== EventEmailTrigger.Confirmation,
                    loading: actionLoading,
                    onClicked: () => {
                      if (!!formData.eventId && !!emailTemplates.title) {
                        setActionLoading(true)
                        const targetTemplate = formData.emailTemplates?.find(
                          (f) => f.title === emailTemplates.title
                        )
                        if (targetTemplate) {
                          const {
                            templateId: _templateId,
                            schedule: _schedule,
                            ...templateCopy
                          } = targetTemplate
                          setFormData({
                            ...formData,
                            emailTemplates: [
                              ...(formData.emailTemplates ?? []),
                              {
                                ...templateCopy,
                                title: `${targetTemplate.title} - Copy`,
                                trigger: EventEmailTrigger.Manual,
                              },
                            ],
                          })
                        }

                        setActionLoading(false)
                      }
                    },
                  },
                ]}
                editClicked={() => {
                  console.log({ emailTemplates, index })
                  setEmailModalData({
                    ...emailTemplates,
                    editIndex: index,
                    trigger: isScheduled
                      ? SCHEDULED_EMAIL_TRIGGER
                      : (emailTemplates.trigger ?? EventEmailTrigger.Manual),
                    schedule:
                      emailTemplates.schedule ??
                      (legacySchedule && scheduledAt
                        ? {
                            scheduleId: '',
                            runAt: scheduledAt,
                            status:
                              legacySchedule.status ??
                              NotificationStatus.Processing,
                          }
                        : undefined),
                    originalTitle: legacySchedule
                      ? (emailTemplates.title ?? undefined)
                      : undefined,
                    legacyScheduleTimestamp:
                      legacySchedule?.timestamp ?? undefined,
                  })
                  setShowEmailModal(true)
                }}
                deleteClicked={
                  emailTemplates.trigger !== EventEmailTrigger.Confirmation
                    ? () => {
                        setFormData({
                          ...formData,
                          emailTemplates: formData?.emailTemplates?.filter(
                            (_, i) => i !== index
                          ),
                          notifications: removeLegacyEmailSchedule({
                            notifications: formData.notifications,
                            templateTitle: emailTemplates.title,
                            timestamp: legacySchedule?.timestamp,
                          }),
                        })
                      }
                    : undefined
                }
              />,
            ]
          })}
        />
        <Box show={formData?.emailTemplates?.length === 0}>
          <Box className="text-sm mt-8 text-center mb-8">
            {'No event emails have been created yet'}
          </Box>
        </Box>
      </Box>
    </>
  )
}

NotificationsForm.Layout = CreateEventLayout

export default NotificationsForm
